import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../lib/assets";

export default function WhatsAppButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-40 group flex items-center gap-3 bg-[#25D366] text-white shadow-lg pl-5 pr-6 py-4 hover:bg-[#128C7E] transition-all duration-300"
      style={{ borderRadius: 0 }}
    >
      <MessageCircle size={22} strokeWidth={1.75} />
      <span className="hidden sm:inline font-heading uppercase tracking-widest text-xs font-semibold">
        Chat with us
      </span>
    </a>
  );
}
